/**
 * Pagination Component
 */
export class Pagination {
    constructor() {
        this.init();
    }

    init() {
        // 전역 함수로 등록 (인라인 onClick과 호환성)
        window.goListMove = (page) => {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', page);
            window.location.href = window.location.pathname + '?' + urlParams.toString();
        };
    }
}

